import React from 'react';
import { useLanguage } from './LanguageContext';
import LanguageToggle from './LanguageToggle';
import { MenuIcon } from './NavIcons';

/**
 * The 56px sticky bar that replaces the sidebar header on a phone. The
 * language toggle lives here because the sidebar footer that used to hold it
 * is off screen, and a Thai front desk must not lose the switch.
 */
const MobileHeader = ({ title, onOpenDrawer, admin }) => {
  const { print_lang } = useLanguage();

  return (
    <header className="mobile-header">
      <button
        type="button"
        className="mobile-header-menu"
        onClick={onOpenDrawer}
        aria-label={print_lang('nav.menu', 'Menu')}
      >
        <MenuIcon className="sidebar-nav-icon" />
      </button>

      <h1 className="mobile-header-title">{title}</h1>

      <div className="mobile-header-right">
        <LanguageToggle />
        <div className="mobile-header-avatar">
          {admin?.name?.charAt(0).toUpperCase() || 'A'}
        </div>
      </div>
    </header>
  );
};

export default MobileHeader;
